/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    id: 1,
    label: 'Date completed',
    field_name: 'date_completed',
    source_field: 'date_completed',
    showColumn: true,
    pinned: true,
  },
  {
    id: 2,
    label: 'Unit',
    field_name: 'unit',
    source_field: 'unit',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Lesson',
    field_name: 'lesson',
    source_field: 'lesson',
    showColumn: true,
  },
  {
    id: 4,
    label: 'Score',
    field_name: 'score',
    source_field: 'score',
    showColumn: true,
  },
];
